import { defineStore, acceptHMRUpdate } from 'pinia'

interface BusinessServiceCardState {
  // Selection state shared between `ServicesTab` and `InfoViewLayout`.
  // Business service details are cached by TanStack Query, not duplicated here.

  selectedBusinessServiceId: string | null
  // Business service id (UUID7) whose card is currently shown in
  // `InfoViewLayout`, or `null` when no service row is selected.
}

/**
 * Cross-component selection state for the business service info card.
 */
export const useBusinessServiceCardStore = defineStore('businessServiceCard', {
  state: (): BusinessServiceCardState => ({
    selectedBusinessServiceId: null,
  }),
  getters: {
    /** Convenience flag for `v-if` guards in components that mount the card. */
    hasSelection: (state): boolean => state.selectedBusinessServiceId !== null,
  },
  actions: {
    /**
     * Open the card for the given business service id. Idempotent so re-clicking
     * the selected row does not force the card through a fresh mount cycle.
     */
    selectBusinessService(id: string): void {
      if (this.selectedBusinessServiceId === id) return
      this.selectedBusinessServiceId = id
    },
    /** Close the card (hides it from `InfoViewLayout`). */
    clearSelection(): void {
      this.selectedBusinessServiceId = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBusinessServiceCardStore, import.meta.hot))
}
